import React, { useState } from "react";
import BarekamInputMultilingual from "../../../../../../pages/components/input-multilingual/barekam-input-multilingual";
import { DialogContent, Grid } from "@mui/material";
import { Message, MessageSections } from "../../../../../../pages/components/message/message";
import { StandardDialogFooter } from "../../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import { getMessage } from "../../../../../../pages/shared/helper-functions";
import { useAppSelector } from "../../../../../../redux/store";
import { BarekamSelect } from "../../../../../../pages/components/select/select";
import { BarekamMenuItem, SelectedBarekamMenuItem } from "../../../../../../pages/components/select/styled/orders";
import { AxiosError } from "axios";
import { mapValidationErrors } from "../../../../../../pages/user/settings/personal-info/personal-info.service";
import { RegionModel } from "../../../../../../pages/shared/models/regionModel";
import regionService from "../../../../../../services/region-service";

const EditRegion = ({ regionData, onCancel }: { regionData: RegionModel, onCancel: () => void }) => {
    const { cities } = useAppSelector(state => state.staticDataReducer);
    const [modifiedRegion, setModifiedRegion] = useState(regionData);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const { messageCache, languageId } = useAppSelector(state => state.messagesReducer);

    function handleChange(field: 'name' | 'city', value: any) {
        setModifiedRegion(prevState => {
            if (field === 'city') {
                const city = cities.find(city => city.cityId === value);

                if (city) {
                    prevState[field] = city;
                }
            } else {
                prevState[field] = value;
            }

            return { ...prevState }
        })
    }

    function validateData() {
        const errors = {} as { [key: string]: string };

        if (!modifiedRegion.name || Object.keys(modifiedRegion.name).length < 1) {
            errors['name'] = 'required';
        }
        if (!modifiedRegion.city) {
            errors['city'] = 'required';
        }
        return errors;
    }

    function handleSave() {
        const errors = validateData();
        setErrors(errors);

        if (Object.keys(errors).length === 0) {
            if (modifiedRegion.regionId) {
                regionService.editRegion(regionData.regionId, modifiedRegion)
                    .then(() => onCancel())
                    .catch(reason => {
                        if (reason instanceof AxiosError) {
                            setErrors(mapValidationErrors(reason));
                        }
                    });
            } else {
                regionService.createRegion(modifiedRegion)
                    .then(() => onCancel())
                    .catch(reason => {
                        if (reason instanceof AxiosError) {
                            setErrors(mapValidationErrors(reason));
                        }
                    });
            }
        }
    }

    return (
        <>
            <DialogContent>
                <Grid container rowSpacing={'1rem'} columnSpacing={'1rem'}>
                    <BarekamInputMultilingual multilingualText={modifiedRegion.name || {}}
                        labelKey={'name'}
                        field={'name'}
                        onChange={(name) => handleChange('name', name)}
                        errors={errors} />


                    <Grid item xs={12}>
                        <BarekamSelect
                            variant={'outlined'}
                            label={getMessage('city', MessageSections.MAIN, messageCache, languageId)}
                            value={modifiedRegion?.city?.cityId || ''}
                            onChange={(value) => handleChange('city', value.target.value)}
                            type={"standard"}
                            error={!!errors['city']}
                            errorMessage={errors['city'] && getMessage(errors['city'], MessageSections.MAIN, messageCache, languageId)}>
                            {cities.map((city, index) => {
                                if (city.cityId === modifiedRegion?.city?.cityId) {
                                    return (
                                        <SelectedBarekamMenuItem value={city.cityId}
                                            key={index}>
                                            {city.name[languageId]}
                                        </SelectedBarekamMenuItem>
                                    )
                                } else {
                                    return (
                                        <BarekamMenuItem value={city.cityId}
                                            key={index}>
                                            {city.name[languageId]}
                                        </BarekamMenuItem>
                                    );
                                }
                            })}
                        </BarekamSelect>
                    </Grid>
                </Grid>
            </DialogContent>

            <StandardDialogFooter onCancel={() => onCancel()}
                onSave={() => handleSave()}
                saveLabel={<Message messageKey={'save'} sectionId={MessageSections.MAIN} />} />
        </>
    );
}

export default EditRegion;